(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name entitats.main.controller:MainCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats.main')
    .controller('MainCtrl', MainCtrl);

  function MainCtrl() {
    var vm = this;
    vm.ctrlName = 'MainCtrl';
  }
}());
